import { Page } from '@roc/feature-app-core';
import { Route, useParams } from 'react-router';

import { AppraisalChat } from '@roc/feature-appraisals';
import { useRocInternalPortalStore } from '../../../hooks';

export const getAppraisalChatInternalRoutesConfig = (
  basePath: string,
  baseUrl: string
) => {
  return {
    appraisalChat: {
      path: `${basePath}/appraisal-chat`,
      url: `${baseUrl}/appraisal-chat`,
      documentTitle: 'appraisal-chat',
    },
  };
};

export const getAppraisalChatInternalRoutes = (
  basePath: string,
  baseUrl: string,
  appraisalId: number
) => {
  const config = getAppraisalChatInternalRoutesConfig(basePath, baseUrl);
  const { appraisalCommunicationStore } = useRocInternalPortalStore();

  return {
    appraisalChat: (
      <Route exact path={config.appraisalChat.path}>
        <Page routeDefinition={config.appraisalChat}>
          <AppraisalChat
            appraisalId={appraisalId}
            store={appraisalCommunicationStore}
          />
        </Page>
      </Route>
    ),
  };
};
